import { _decorator, Component, EventTouch, NodeEventType } from 'cc';

const { ccclass } = _decorator;
const blockEvents = [
    NodeEventType.TOUCH_START,
    NodeEventType.TOUCH_MOVE,
    NodeEventType.TOUCH_END,
    NodeEventType.TOUCH_CANCEL,
    NodeEventType.MOUSE_DOWN,
    NodeEventType.MOUSE_MOVE,
    NodeEventType.MOUSE_UP,
    NodeEventType.MOUSE_ENTER,
    NodeEventType.MOUSE_LEAVE,
    NodeEventType.MOUSE_WHEEL,
];

@ccclass('PreventSwallowInputEvents')
export default class PreventSwallowInputEvents extends Component {
    protected onEnable() {
        blockEvents.forEach((eventType) => {
            this.node.on(eventType, this._preventSwallow, this);
        });
    }

    protected onDisable() {
        blockEvents.forEach((eventType) => {
            this.node.off(eventType, this._preventSwallow, this);
        });
    }

    private _preventSwallow(event: EventTouch) {
        event.preventSwallow = true;
    }
}
